import Vue from "vue";
const vm = new Vue();

export const getMarketplace = (page) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_MARKETPLACE}/${Number(sessionStorage.aid)}?page=${page}`)
      .then((res) => {
        res.status == 200 ? resolve(res.data) : reject();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPartnerMarketplace = (partner_name, account_id, extension_id) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_PARTNER_MARKETPLACE}/${partner_name}/${account_id}/${extension_id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCategoryMarketplace = (category_group, account_id, page) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(vm.$endpoint.GET_CATEGORY_MARKETPLACE(category_group, account_id), {
        params: { page },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getMarketplaceSearch = (id, query) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_MARKETPLACE_SEARCH}?${query.substr(1)}&account_id=${id}`)
      .then((res) => {
        res.status == 200 ? resolve(res.data) : reject();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getFavorite = () => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_PREFERENCES_MARKETPLACE}`)
      .then((res) => {
        res.status == 200 ? resolve(res.data) : reject();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const postPreference = (params) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .post(`${vm.$endpoint.UPDATE_PREFERENCES_MARKETPLACE}`, params)
      .then((res) => {
        res.status == 200 ? resolve(res.data) : reject();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getFavoriteMarketplace = () => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(`${vm.$endpoint.GET_PRODUCT_FAVORITE}?account_id=${sessionStorage.aid}`)
      .then((res) => {
        res.status == 200 ? resolve(res.data) : reject();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
